import { render, staticRenderFns } from "./DeliveryPointPickUpAttemptsCard.vue?vue&type=template&id=0b559f9e&scoped=true"
import script from "./DeliveryPointPickUpAttemptsCard.vue?vue&type=script&lang=js"
export * from "./DeliveryPointPickUpAttemptsCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPointPickUpAttemptsCard.vue?vue&type=style&index=0&id=0b559f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b559f9e",
  null
  
)

export default component.exports